module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-bold-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-bold-webfont.ttf
// module id = 139
// module chunks = 3